/**
 * A hook to allow LiveView to set the indeterminate state on a checkbox.
 *
 * Irritatingly, you can't set an indeterminate state in HTML, so we have to use JS.
 */
import { Hook, makeHook } from './Hook'

export default makeHook(
  class IndeterminateCheckbox extends Hook {
    mounted() {
      this.updated()
    }

    updated() {
      const checkbox = this.el as HTMLInputElement
      if (!checkbox) return
      checkbox.indeterminate = checkbox.hasAttribute('data-indeterminate')
    }
  }
)
